import React,{useState,useEffect} from "react";
import {login} from "../../redux/actions/userActions";
import {Link, Redirect} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input
} from "reactstrap";
import API from "../../utils/API";
import PasswordChecklist from "react-password-checklist"

const Registration = (props) => {
    const [password,setPassword] = useState('');
    const [confirmpassword,setConfirmpassword] = useState('');
    const [name,setName] = useState(null);
    const [error,setError] = useState(null);
    const [validPassword,setValidPassword] = useState(false);

    const dispatch = useDispatch();

    const sign = useSelector(state => {
        return state.user.sign
    });

    useEffect(() => {
        API.get('/user/registration/'+props.match.params.id).then((response) => {
            setName(response.data.data.name)
        }).catch(error => {
            setError('Invalid invitation')
        })
    }, [])

    const submit = (e) => {
        e.preventDefault();
        if (!name || name.length < 2) {
            setError('Invalid name')
            return;
        }

        API.post('/user/register/'+props.match.params.id,{password:password,name:name})
            .then(data => {
                dispatch(login(data.data.data));
            })
            .catch(error => {
                setError('Invalid invitation')
            })
    }

    return (
        sign ?
            <Redirect to="/"/>
            :
            <React.Fragment>
                <div className="text-center mt-4">
                    <h1 className="h2">Registration</h1>
                </div>
                <Card>
                    <CardBody>
                        <div className="m-sm-4">
                            {error &&
                            <div className="text-center text-danger">{error}</div>
                            }
                            <Form onSubmit={submit}>
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input
                                        bsSize="lg"
                                        type="text"
                                        name="name"
                                        value={name}
                                        placeholder="Enter your name"
                                        onChange={(e) => {setName(`${e.target.value}`);setError(null)}}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Password</Label>
                                    <input type="password" className="form-control" onChange={e => setPassword(e.target.value)}/>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Confirm password</Label>
                                    <input type="password" className="form-control" onChange={e => setConfirmpassword(e.target.value)}/>
                                    <PasswordChecklist
                                        rules={["minLength","specialChar","number","capital","match"]}
                                        minLength={8}
                                        value={password}
                                        valueAgain={confirmpassword}
                                        onChange={(isValid) => {setValidPassword(isValid)}}
                                    />
                                </FormGroup>
                                <div className="text-center mt-3">
                                    <Button color="primary" size="lg" type="submit" disabled={!validPassword}>
                                        Save
                                    </Button>
                                </div>
                            </Form>
                            <div className="text-center mt-2">
                                <small>
                                    <Link to="/auth/sign-in">Back to Sign In</Link>
                                </small>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </React.Fragment>
    )
}

export default Registration;
